export default __webpack_public_path__ + "static/media/multicar6.328ac566.jpeg";